// TextBadge.tsx
import React from 'react';
import { getBadgeStyles } from './styleUtils';
import { COLOR_TYPE, SIZE } from '../globalTypes';
import { theme } from './theme';

export type TextBadgeProps = {
	text: string;
	icon?: React.ReactNode;
	onClickIcon?: () => void;
	size?: SIZE;
	type?: COLOR_TYPE;
	iconStart?: boolean;
	style?: React.CSSProperties;
};

export const TextBadge: React.FC<TextBadgeProps> = ({
	text,
	icon,
	onClickIcon,
	size = 'md',
	type = 'primary',
	iconStart = false,
	style
}) => {
	const styles = getBadgeStyles(theme);
	const badgeStyle = {
		...styles.badge_css(size),
		...styles.badgeTextColor_css(type),
		...styles.badgeBackground_css(type),
		...style
	};

	return (
		<div className={`text-badge ${size}`} style={badgeStyle}>
			{icon && iconStart && (
				<span className="badge-icon" style={styles.badgeIcon_css} onClick={onClickIcon}>
					{icon}
				</span>
			)}
			<span className="badge-text" style={styles.badgeText_css}>
				{text}
			</span>
			{icon && !iconStart && (
				<span className="badge-icon" style={styles.badgeIcon_css} onClick={onClickIcon}>
					{icon}
				</span>
			)}
		</div>
	);
};
